import styled from 'styled-components'
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px;
  gap: 20px;
  width: 100%;

  img {
    max-width: 400px;
    min-width: 220px;
    width: 100%;
  }
`
export const Title = styled.h2`
  font-size: 120px;
`
export const Text = styled.p`
  font-size: 20px;
`
